// A person's name as shown anywhere in the app: trimmed, never blank (review F13 —
// some stored names end in a space, which showed as "Hi User 1 !").
export const displayName = (name, fallback = 'Study partner') => (name || '').trim() || fallback;

// "USMLE Step 1" for the stored "USMLE STEP 1", outside chips (review R7).
export const examLabel = cat => (cat || '').replace('STEP', 'Step');

